// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  font-size: 0.9rem;
  background-color: #f5fae1;
}
body,
.form-control {
  font-size: 0.9rem;
}
body,
html,
#root,
.App {
  min-height: 100vh;
}

.btn {
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0.66rem;
  border-radius: 0.5rem;
  box-shadow: 0 0.1rem 0.1rem rgba(0, 0, 0, 0.05) !important;
}
.App-link {
  color: #61dafb;
}

.btn-light {
  border-color: #dedede;
}

.btn-light:hover {
  border-color: #dedede;
  background-color: #f3f3f3;
}

.shadow {
  box-shadow: 0 0.1rem 0.1rem rgba(0, 0, 0, 0.05) !important;
}

.modal-content,
.card {
  overflow: hidden;
  border-radius: 0.756rem;
}

hr {
  opacity: 0.1;
}

.table th {
  border-top: 1px solid #0000001a;
  border-bottom: 1px solid #0000001a;
  border-bottom-color: #0000001a !important;
}
.table td {
  text-align: left;
}
.table tr th:first-child,
.table tr td:first-child {
  padding-left: 0;
}
.table tr th:last-child,
.table tr td:last-child {
  padding-right: 0;
}

.form-control {
  background: #f5f7f9;
  font-weight: 400;
  padding: 0.5rem 0.75rem;
  border: none;
}
.form-control:hover {
  background: #f5f7f9;
}
.form-control::placeholder,
.form-control::-ms-input-placeholder,
.form-control:-ms-input-placeholder {
  color: #9fa8b0;
}
.form-control:focus {
  background: #f5f7f9;
}

#invoiceCapture {
  -webkit-user-select: none;
  user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;EAEE,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;;EAEE,iBAAiB;AACnB;AACA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,0DAA0D;AAC5D;AACA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,yCAAyC;AAC3C;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EAGzB,iBAAiB;AACnB","sourcesContent":["body,\nhtml {\n  font-size: 0.9rem;\n  background-color: #f5fae1;\n}\nbody,\n.form-control {\n  font-size: 0.9rem;\n}\nbody,\nhtml,\n#root,\n.App {\n  min-height: 100vh;\n}\n\n.btn {\n  font-size: 0.9rem;\n  font-weight: 500;\n  padding: 0.66rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 0.1rem 0.1rem rgba(0, 0, 0, 0.05) !important;\n}\n.App-link {\n  color: #61dafb;\n}\n\n.btn-light {\n  border-color: #dedede;\n}\n\n.btn-light:hover {\n  border-color: #dedede;\n  background-color: #f3f3f3;\n}\n\n.shadow {\n  box-shadow: 0 0.1rem 0.1rem rgba(0, 0, 0, 0.05) !important;\n}\n\n.modal-content,\n.card {\n  overflow: hidden;\n  border-radius: 0.756rem;\n}\n\nhr {\n  opacity: 0.1;\n}\n\n.table th {\n  border-top: 1px solid #0000001a;\n  border-bottom: 1px solid #0000001a;\n  border-bottom-color: #0000001a !important;\n}\n.table td {\n  text-align: left;\n}\n.table tr th:first-child,\n.table tr td:first-child {\n  padding-left: 0;\n}\n.table tr th:last-child,\n.table tr td:last-child {\n  padding-right: 0;\n}\n\n.form-control {\n  background: #f5f7f9;\n  font-weight: 400;\n  padding: 0.5rem 0.75rem;\n  border: none;\n}\n.form-control:hover {\n  background: #f5f7f9;\n}\n.form-control::placeholder,\n.form-control::-ms-input-placeholder,\n.form-control:-ms-input-placeholder {\n  color: #9fa8b0;\n}\n.form-control:focus {\n  background: #f5f7f9;\n}\n\n#invoiceCapture {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
